export default __webpack_public_path__ + "static/media/img2.81a0338c.png";